var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 22.5,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2917 14.8821L32.1179 12.7083L23.5 21.3263L14.8821 12.7083L12.7083 14.8821L21.3263 23.5L12.7083 32.1179L14.8821 34.2917L23.5 25.6738L32.1179 34.2917L34.2917 32.1179L25.6738 23.5L34.2917 14.8821Z",
    fill: "#1F1F1F"
  })));
};
export default SvgIconClose;